  export enum RangeUploadTypeEnum
  {
      Family_Grading = 1,
      Store_Only = 2,
      OffRange = 3
  }
 
   export const RangeUploadTypeEnumLabel =
  {
      [RangeUploadTypeEnum.Family_Grading] : "Family Grading",
      [RangeUploadTypeEnum.Store_Only] : "Store Only",
      [RangeUploadTypeEnum.OffRange] :    "Off Range"
  }
  